import store from "@/store";

export default (to: any, from: any, next: any) => {
  document.title = to.meta.title;
  store.dispatch("authorize", next);
};
